import { render, staticRenderFns } from "./Dogs-main.vue?vue&type=template&id=591478a2&scoped=true&"
import script from "./Dogs-main.vue?vue&type=script&lang=js&"
export * from "./Dogs-main.vue?vue&type=script&lang=js&"
import style0 from "./Dogs-main.vue?vue&type=style&index=0&id=591478a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591478a2",
  null
  
)

export default component.exports